import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { usePOTemplateDnd } from './contextProvider/POTemplateDndContext';

/**
 * GrandTotal Component
 * Handles grand total information including grand total units, grand total price after discount,
 * and shipping costs with proper state management and onChange handling
 */
export default function GrandTotal({ isPreviewMode = false }) {
  const { t } = useTranslation('purchase-order');
  const { detailState, setDetailState } = usePOTemplateDnd();

  /**
   * Handle input changes for grand total fields
   * @param {Event} e - Input change event
   */
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDetailState((prevState) => ({
      ...prevState,
      grandTotal: {
        ...prevState.grandTotal,
        [name]: value,
      },
    }));
  };

  const grandTotal = detailState?.grandTotal || {};

  return (
    <div className="inner-container grand-total-section p-10">
      <div className="section-template-title mb-0">{t('PO_TEMPLATE.GRAND_TOTAL.TITLE', 'Grand Total')}</div>
      <div className="d-flex p-10">
        <div className="common-input-control flex-fill mr-16 mb-0">
          <p className="field-name">{t('PO_TEMPLATE.GRAND_TOTAL.GRAND_TOTAL_UNITS', 'Grand Total Units')}</p>
          {isPreviewMode ? (
            <div className="form-control-plaintext">{grandTotal.grandTotalUnits || '--'}</div>
          ) : (
            <input
              type="number"
              name="grandTotalUnits"
              placeholder={t('PO_TEMPLATE.DETAIL_PAGE.AUTO_FILLED', 'Auto Filled')}
              className="form-control"
              value={grandTotal.grandTotalUnits || ''}
              onChange={handleInputChange}
              min={0}
              disabled
            />
          )}
        </div>
        <div className="common-input-control flex-fill mr-16 mb-0">
          <p className="field-name">{t('PO_TEMPLATE.GRAND_TOTAL.GRAND_TOTAL_PRICE_AFTER_DISCOUNT', 'Grand Total Price (After Discount)')}</p>
          {isPreviewMode ? (
            <div className="form-control-plaintext">{grandTotal.grandTotalPriceAfterDiscount || '--'}</div>
          ) : (
            <input
              type="number"
              name="grandTotalPriceAfterDiscount"
              placeholder={t('PO_TEMPLATE.DETAIL_PAGE.AUTO_FILLED', 'Auto Filled')}
              className="form-control"
              value={grandTotal.grandTotalPriceAfterDiscount || ''}
              onChange={handleInputChange}
              min={0}
              disabled
            />
          )}
        </div>
      </div>
    </div>
  );
}

GrandTotal.propTypes = {
  isPreviewMode: PropTypes.bool,
};

GrandTotal.defaultProps = {
  isPreviewMode: false,
};
